export enum StatusType {
  Asn = 'Asn',
  Orders = 'Orders',
  Inventory = 'Inventory',
  Users = 'User',
}
